import { type ReactNode, useCallback } from 'react';

import { getQuestion, type Lang, type Question } from '@/api';
import { Session } from '@/pages/practice/Session';
import { useLangSyncedQuestions } from '@/pages/practice/useLangSyncedQuestions';
import type { Strings } from '@/str';

export function SyncedSession({
  initial,
  initialLang,
  t,
  onDone,
  onMore,
  onProgress,
  onFinish,
  intro,
  label,
  summary,
}: {
  initial: Question[];
  initialLang: Lang;
  t: Strings;
  onDone: () => void;
  onMore?: () => void;
  onProgress?: (index: number) => void;
  onFinish?: () => void;
  intro?: ReactNode;
  label?: string;
  summary?: boolean;
}) {
  const fetchIn = useCallback(
    (l: Lang) => Promise.all(initial.map((q) => getQuestion(q.id, l))),
    [initial],
  );
  const questions = useLangSyncedQuestions(initial, initialLang, fetchIn);
  return (
    <Session
      questions={questions}
      t={t}
      onDone={onDone}
      onMore={onMore}
      onProgress={onProgress}
      onFinish={onFinish}
      intro={intro}
      label={label}
      summary={summary}
    />
  );
}
